import L from 'lodash'

import {
  REQUEST_URLS as urls,
  ERROR_PLACEHOLDERS as errorTexts,
} from '@straal/kompas/staticViews/_assets/scripts/consts'
import { REGULAR_EXPRESSIONS as regExp } from '@straal/globals/configs/coreConsts.ts'

import { ajaxRequest } from '@straal/kompas/staticViews/_assets/scripts/ajax'

export const confirmValidator = function({ compareWith }, value, store) {
  const otherValue = store.getInputValue(compareWith)
  const isFieldValid = value === otherValue

  return {
    valid: isFieldValid,
    errors: isFieldValid ? null : errorTexts.PASSWORD_CONFIRM_FIELD_INVALID,
  }
}

export const passwordValidator = async function(password) {
  const hasPassword = Boolean(password)

  if (hasPassword) {
    const response = await ajaxRequest(urls.VALIDATE_PASSWORD, 'POST', {
      password,
    })
    const isFieldValid = !L.get(response, 'errors.length', 0) > 0

    return {
      valid: isFieldValid,
      errors: isFieldValid ? null : response.errors,
    }
  }
  return {
    valid: false,
    errors: ['Password field is required!'],
  }
}

export const emailValidator = function(value) {
  const emailRegExp = new RegExp(regExp.EMAIL)
  const isFieldValid = emailRegExp.test(value)

  return {
    valid: isFieldValid,
    errors: isFieldValid ? null : [errorTexts.INVALID_EMAIL],
  }
}
